export default {
  home: {
    title: 'TAXIBUS - A SHARED TAXI SERVICE ',
    subTitle: 'MAKE YOUR RESERVATION NOW',
    suppliers: {
      EXO: 'MAKE YOUR RESERVATION NOW',
      STL: 'MAKE YOUR RESERVATION NOW',
    }
  }
};